import React, { useRef, useMemo } from 'react';
import cloneDeep from 'lodash/cloneDeep';

import ReactEcharts from "echarts-for-react";

const SunburstChart = ({ options, data, handleChartClick }) => {
    const chartOptions = useMemo(() => {
        const newChartOptions = cloneDeep(options);
        newChartOptions.series.data = data;
        return newChartOptions;
    }, [data, options]);

    const chartRef = useRef(null);

    // const resizeChart = () => {
    //     chartRef.current.chart.reflow();
    // };
    
      const onEvents = {
        click: handleChartClick,
      };

    // useEffect(() => {
    //     resizeChart();
    // }, [width]);

    return (
        <ReactEcharts
            constructorType="chart"
            option={{
                ...chartOptions
            }}
            onEvents={onEvents}
            ref={chartRef}
            containerProps={{ className: 'glu-sunburst' }}
        />
    );
}

export default SunburstChart;
